export const PRODUCT_LOCK_TIME_EXPIRING = 'product-lock-time-expiring';
export const PRODUCT_LOCK_QUANTITY_EXPIRING = 'product-lock-quantity-expiring';
export const PRODUCT_LOCK_UPDATED = 'product-lock-updated';
export const PRODUCT_LOCK_CREATED = 'product-lock-created';
export const PRODUCT_LOCK_REMOVED = 'product-lock-removed';
export const PRODUCT_LOCK_REJECTED = 'product-lock-request-rejected';
export const RECOMMENDATION_CREATED = 'recommendation-created';
